import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const AddBulkTimeOffButton = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Button
      onClick={() => navigate(navigation.calendar.bulkAddTimeOff.fullPath())}
      type="secondary"
      iconName="time-off"
    >
      {i18n.t('sidebar.add_button.actions.add_timeoff.title')}
    </Button>
  )
}

export default AddBulkTimeOffButton
